/** Mirrors a shell state onto an attribute of <html> so stylesheets can key
 *  off it with a plain attribute selector. The alternative, `:has()` ahead of a
 *  descendant combinator, made Chrome restyle the whole page on every DOM
 *  insertion. Counted, so two mounted owners never clear each other's flag. */
import { useEffect } from 'react';

const holders = new Map<string, number>();

export function useDocumentFlag(attribute: string, on: boolean): void {
  useEffect(() => {
    if (!on) return;
    const root = document.documentElement;
    holders.set(attribute, (holders.get(attribute) ?? 0) + 1);
    root.setAttribute(attribute, 'true');
    return () => {
      const remaining = (holders.get(attribute) ?? 1) - 1;
      if (remaining > 0) {
        holders.set(attribute, remaining);
        return;
      }
      holders.delete(attribute);
      root.removeAttribute(attribute);
    };
  }, [attribute, on]);
}
